import React, { useState, useEffect, useRef } from "react";
import {
  Menu,
  X,
  ChevronDown,
  Home,
  Users,
  Package,
  Settings as Cog,
} from "lucide-react";
import { BarChart3 } from "lucide-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { IoLogoWebComponent } from "react-icons/io5";
import { MdOutlineSettingsInputComponent } from "react-icons/md";
import { FaIdBadge } from "react-icons/fa6";
import { GrProductHunt } from "react-icons/gr";
import { BsDatabaseFillGear } from "react-icons/bs";
// import ApiManager from "./PRODUCT/API_Keys/ApiManager"
import { GiThreeKeys } from "react-icons/gi";
import { MdManageAccounts } from "react-icons/md";
import ActiveCount from "./HRMS/ActiveCount";
// HRMS Components
import Welcome from "./HRMS/Welcome";
import Usertype from "./HRMS/Usertype";
import UserTypePrivileges from "./HRMS/UserTypePrivileges";
import { FaPhoneVolume } from "react-icons/fa6";
// PRODUCT Components
import Product from "./PRODUCT/Pruduct_group/ProductGroup";
import ProductCategory from "./PRODUCT/Pruduct_group/ProductCategory";
import ProductMaster from "./PRODUCT/Product/Product";
import FeaturesMapping from "./PRODUCT/ComponentsMapping/FeaturesMapping";
// import Welcome1 from './PRODUCT/Welcome/Welcome';
import Features from "./PRODUCT/ComponentList/Features";
import ManageProducts from "./../../Manageproducts/Manageproduct";
import Coupons from "./../../Coupons/Coupons";
import ManageOrders from "./../../Orders/ManageOrders";
import Settings from "../../Admin/Settings";
import ReturnedOrders from "../../Admin/ReturnedOrders";
import axiosClient from "../../global/Globalapi";
import { FaCartFlatbed } from "react-icons/fa6";
import { TbTruckReturn } from "react-icons/tb";
import { MdProductionQuantityLimits } from "react-icons/md";
import { RiCoupon2Line } from "react-icons/ri";
import ThemePage from "../ThemePage";
import EmailBroadcast from "./HRMS/EmailBroadcast";
import { MdEmail } from "react-icons/md";
import { AiFillShop } from "react-icons/ai";
import SMSBroadcast from "./HRMS/SmsBroadcast";
import AffiliateUserLogin from "./HRMS/personalInfo";
import AffiliateCampaign from "./HRMS/affiliateCampaign";
import { GoSignOut } from "react-icons/go";
import { useLocation } from "react-router-dom";
import ProductBarcodePage from "./PRODUCT/Product/ProductBarcodePage";
import BatchManagement from "./PRODUCT/Product/BatchManagement .js";
import AnalyticsDashboard from "../../pages/AnalyticsDashboard";
import { BRAND_NAME } from "../../global/Globalapi";
import RegionMasterForm from "../../Branch/RegionMasterForm.js";
import BranchMasterForm from "../../Branch/BranchMasterForm .js";
import { Map, Building2 } from "lucide-react";
import { MdCategory } from "react-icons/md";
import { TbListDetails } from "react-icons/tb";
import { MdDashboard } from "react-icons/md";
import { FaUsersCog } from "react-icons/fa";
import swal from 'sweetalert';
const Sidebar = () => {
  const handleMouseEnter = () => setExpanded(true);
  const [isOpen, setIsOpen] = useState(true);
  const [sidebarData, setSidebarData] = useState([]);
  const [activeParent, setActiveParent] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(0);
  const [mobileView, setMobileView] = useState(window.innerWidth < 768);
  const baseURL = axiosClient.defaults.baseURL;
  const [currentSection, setCurrentSection] = useState("home");
  const navigate = useNavigate();
  const location = useLocation();
const [offAll, setOffAll] = useState(0);
const [toggleLoading, setToggleLoading] = useState(false);
  const sidebarRef = useRef(null);

  const iconMap = {
    HOME: <Home size={32} className="text-black" />,
    PRODUCT: <Package size={32} className="text-black" />,
    HRMS: <FaUsersCog  size={32} className="text-black" />,
    User: <Users size={28} />,
    "Types": <FaIdBadge size={24} />,
    "Privileges": <BsDatabaseFillGear size={24} />,
    Component: <MdOutlineSettingsInputComponent size={24} />,
    "Components Mapping": <IoLogoWebComponent size={24} />,
    "Product Group": <Cog size={24} />,
    "Master": <GrProductHunt size={24} />,
    barcodeGeneration: <AiFillShop size={24}/>,
    addBatches: <AiFillShop size={24}/>,
    APIManagement: <GiThreeKeys size={24} />,
    Settings: <Cog size={24} />,
    ReturnedOrders: <TbTruckReturn size={24} />,
    Manage: <MdManageAccounts size={24} />,
    ORDERS: <FaCartFlatbed size={24} className="text-black " />,
    Coupons: <RiCoupon2Line size={24} />,
    Manage: <MdProductionQuantityLimits size={24} />,
    EmailBroadcast: <MdEmail size={24} />,
    MARKETING: <AiFillShop size={32} className="text-black" />,
    SETTINGS: <Cog size={32} className="text-black" />,
    Theme: <Cog size={24} />,
    SmsBroadcast: <FaPhoneVolume size={24} />,
    affiliateUserLogin: <AiFillShop size={24} />,
    AffiliateCampaign:<AiFillShop size={24} />,
    AnalyticsDashboard: <BarChart3 size={24} />,
    Region: <Map size={24} />,
    Branch: <Building2 size={24} />,
Category: <MdCategory size={24} />,
Type: <TbListDetails size={24} />,
DASHBOARD: <MdDashboard size={24} />,
  };

useEffect(() => {
  if (location.state?.section) {
    setCurrentSection(location.state.section);
  }
}, [location.state]);

  // useEffect(() => {
  //   if (location.state?.section) {
  //     setCurrentSection(location.state.section);
  //     setActiveParent("PRODUCT");
  //     setExpanded(true); // must match sidebar title
  //   }
  // }, [location.state]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const usertypeid = localStorage.getItem("usertypeid");

    if (!token || !usertypeid) {
      navigate("/adminuser", { replace: true });
    } else {
      fetch(`${baseURL}/api/sidebar/with-privileges/${usertypeid}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.json())
        // .then((data) => {
        //   setSidebarData(data);
        //   console.log(data);
        // })
//         .then((data) => {
          
//   const moduleOrder = ["HOME", "ORDERS", "PRODUCT", "HRMS", "SETTINGS"];

//   const sortedData = [...data].sort((a, b) => {
//     const indexA = moduleOrder.indexOf(a.title);
//     const indexB = moduleOrder.indexOf(b.title);

//     const safeIndexA = indexA === -1 ? 999 : indexA;
//     const safeIndexB = indexB === -1 ? 999 : indexB;

//     return safeIndexA - safeIndexB;
//   });

//   setSidebarData(sortedData);
//   console.log(sortedData);
// })
.then((data) => {
  const moduleOrder = ["HOME", "ORDERS", "PRODUCT", "HRMS", "SETTINGS"];
  const hrmsChildOrder = ["User", "Types", "Privileges"];
  const productChildOrder = ["Manage", "Master", "Category", "Type"];

  const sortedWithChildren = data.map((item) => {
    if (Array.isArray(item.children)) {
      if (item.title === "HRMS") {
        const sortedChildren = [...item.children].sort((a, b) => {
          const indexA = hrmsChildOrder.indexOf(a.label);
          const indexB = hrmsChildOrder.indexOf(b.label);

          const safeIndexA = indexA === -1 ? 999 : indexA;
          const safeIndexB = indexB === -1 ? 999 : indexB;

          return safeIndexA - safeIndexB;
        });

        return { ...item, children: sortedChildren };
      }

      if (item.title === "PRODUCT") {
        const sortedChildren = [...item.children].sort((a, b) => {
          const indexA = productChildOrder.indexOf(a.label);
          const indexB = productChildOrder.indexOf(b.label);

          const safeIndexA = indexA === -1 ? 999 : indexA;
          const safeIndexB = indexB === -1 ? 999 : indexB;

          return safeIndexA - safeIndexB;
        });

        return { ...item, children: sortedChildren };
      }
    }

    return item;
  });

  const sortedData = [...sortedWithChildren].sort((a, b) => {
    const indexA = moduleOrder.indexOf(a.title);
    const indexB = moduleOrder.indexOf(b.title);

    const safeIndexA = indexA === -1 ? 999 : indexA;
    const safeIndexB = indexB === -1 ? 999 : indexB;

    return safeIndexA - safeIndexB;
  });

  setSidebarData(sortedData);
  console.log(sortedData);
})
        .catch((err) => {
          console.error("Failed to fetch sidebar:", err);
          navigate("/adminuser", { replace: true });
        });
    }
  }, [navigate]);

  const handleSignOut = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  useEffect(() => {
    let timer;
    if (expanded) {
      timer = setTimeout(() => {
        setExpanded(false);
      }, 7000);
    }
    return () => clearTimeout(timer);
  }, [expanded, resetTrigger]);

  const renderSection = () => {
    switch (currentSection) {
      case "user":
        return <Welcome />;
      case "usertype":
        return <Usertype />;
      case "privileges":
        return <UserTypePrivileges />;
      case "productgroup":
        return <Product />;
      case "productcategory":
        return <ProductCategory />;
      case "productmaster":
        return <ProductMaster />;
      case "features":
        return <Features />;
      case "featuresmapping":
        return <FeaturesMapping />;
      case "ManageProduct":
        return <ManageProducts />;
      case "Coupons":
        return <Coupons />;
      case "ManageOrders":
        return <ManageOrders />;
      case "Settings":
        return <Settings />;
      case "ReturnedOrders":
        return <ReturnedOrders />;
      case "theme":
        return <ThemePage />;
      case "emailbroadcast":
        return <EmailBroadcast />;
      case "smsbroadcast":
        return <SMSBroadcast />;
      case "affiliateUserLogin":
        return <AffiliateUserLogin />;
      case "affiliateCampaign":
        return <AffiliateCampaign/>
      case "barcodeGeneration":
        return <ProductBarcodePage/>
       case "addBatches":
        return <BatchManagement/>
           case "analytics-dashboard":
        return <AnalyticsDashboard/>
      case "regionMaster":
        return <RegionMasterForm/>
      case "branchMaster":
        return <BranchMasterForm/>
      
      default:
        return <ActiveCount />;
    }
  };
  // Update mobileView on resize
  useEffect(() => {
    const handleResize = () => setMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Toggle menu only in mobile view
  const toggleMenu = () => {
    if (mobileView) setIsOpen((prev) => !prev);
  };
const fetchOffAllStatus = async () => {
  try {
    const res = await axiosClient.get("/api/product/off-all-status");
    setOffAll(Number(res.data?.off_all || 0));
  } catch (error) {
    // console.error("Failed to fetch off_all status:", error);
     console.warn("⚠️ off_all status not available, using default (0)");
    setOffAll(0);
  }
};

// const handleToggleOffAll = async () => {
//   if (toggleLoading) return;

//   const newValue = offAll === 1 ? 0 : 1;

//   try {
//     setToggleLoading(true);

//     await axiosClient.put("/api/product/update-off-all", {
//       off_all: newValue,
//     });

//     setOffAll(newValue);
//   } catch (error) {
//     console.error("Failed to update off_all:", error);
//   } finally {
//     setToggleLoading(false);
//   }
// };
const handleToggleOffAll = async () => {
  if (toggleLoading) return;

  const isTurningOff = offAll === 0;

  const confirm = await swal({
    title: "Are you sure?",
    text: isTurningOff
      ? "This will CLOSE the shop !"
      : "This will OPEN the shop !",
    icon: "warning",
    buttons: ["Cancel", isTurningOff ? "Yes, Close Shop" : "Yes, Open Shop"],
    dangerMode: true,
  });

  if (!confirm) return;

  const newValue = isTurningOff ? 1 : 0;

  try {
    setToggleLoading(true);

    await axiosClient.put("/api/product/update-off-all", {
      off_all: newValue,
    });

    setOffAll(newValue);

    swal(
      "Success",
      newValue === 1 ? "Shop is now CLOSED" : "Shop is now OPEN",
      "success"
    );
  } catch (error) {
    console.error("Failed to update off_all:", error);

    swal("Error", "Failed to update shop status", "error");
  } finally {
    setToggleLoading(false);
  }
};
useEffect(() => {
  // fetchOffAllStatus();
  setOffAll(0);
}, []);

  const sidebarClasses = mobileView
    ? `${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } fixed top-0 left-0 h-full ${
        expanded ? "w-64" : "w-16"
      } z-40  text-white transform transition-transform duration-300`
    : `sticky top-4 h-screen min-h-full ${
        expanded ? "w-60" : "md:w-[3%] w-[12%]"
      } transition-all duration-300 bg-[#c97c5d]  text-white`;

  return (
    <div className="flex">
      {/* Mobile Backdrop */}
      {mobileView && isOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      {isOpen && (
        <div ref={sidebarRef} className={sidebarClasses}>
          <nav className="mt-40 -translate-y-20">
            {sidebarData.map((item, idx) => (
              <div key={idx}>
                {/* Parent */}
                <div
                  className={`cursor-pointer flex items-center gap-2 py-2 my-3 hover:bg-white transition-all duration-300 
          ${expanded ? "px-4" : "justify-center w-full"}`}
                  onClick={() => {
                    setActiveParent((prev) =>
                      prev === item.title ? null : item.title
                    );
                    setResetTrigger((prev) => prev + 1);
                  }}
                  onMouseEnter={handleMouseEnter}
                >
                  {iconMap[item.title] || <Home size={32} />}
                  {expanded && (
                    <span className="text-black text-xl font-bold">
                      {item.title}
                    </span>
                  )}
                </div>

                {/* Smooth Submenu */}
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    activeParent === item.title
                      ? "max-h-[400px] opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  {/* <div className="overflow-y-auto max-h-96 scrollbar-hide"> */}
                  <div
                    className="overflow-y-auto max-h-96 
            scrollbar 
            scrollbar-thumb-orange-500 
            scrollbar-track-orange-500 
            scrollbar-thin"
                  >
                    {item.children.map((child, cidx) => (
                      <div
                        key={cidx}
                        className={`py-4 pr-2 hover:bg-black cursor-pointer flex items-center ${
                          expanded
                            ? "space-x-2 ml-4 pl-4"
                            : "justify-center pl-0"
                        }`}
                        onClick={() => {
                          // setCurrentSection(child.section);
                          setCurrentSection(child.section || child.section_key);

                          setResetTrigger((prev) => prev + 1);
                        }}
                        onMouseEnter={handleMouseEnter}
                      >
                        {iconMap[child.label] || <Home size={30} />}
                        {expanded && (
                          <span className="text-lg font-semibold">
                            {child.label}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </nav>
        </div>
      )}

      {/* Top Navbar */}
      <div className="fixed top-0 left-0 right-0 bg-black border-black border-2 p-3 flex items-center justify-between z-50">
        {/* just a place holder */}
        {!mobileView && (
          <button className="bg-transparent -ml-4" onClick={toggleMenu}>
            {/* <Menu size={28} /> */}
          </button>
        )}
        {/* Show toggle button only in mobile view */}
        {mobileView && (
          <button className="bg-transparent -ml-4" onClick={toggleMenu}>
            <Menu size={28} />
          </button>
        )}
        {/* <h1 className="text-xl font-bold flex justify-end text-white">
    
         {BRAND_NAME}
        </h1> */}
        <div className="flex items-center gap-4">
  {/* Toggle Button */}
 <button
  type="button"
  disabled={toggleLoading}
  onClick={handleToggleOffAll}
  className={`relative w-16 h-9 rounded-full transition-all duration-300 ${
    offAll === 0 ? "bg-green-500" : "bg-gray-400"
  } ${toggleLoading ? "opacity-60 cursor-not-allowed" : ""}`}
>
  <span
    className={`absolute top-1 left-1 w-7 h-7 rounded-full bg-white shadow-md transition-all duration-300 ${
      offAll === 0 ? "translate-x-7" : "translate-x-0"
    }`}
  />
</button>

  {/* Brand Name */}
  <h1 className="text-xl font-bold text-white whitespace-nowrap">
    {BRAND_NAME}
  </h1>
</div>
        <div className="flex gap-3">
          <FontAwesomeIcon icon={faUser}  className="my-auto text-red-600 text-2xl hover:scale-110 transition-all duration-100"/>
            <button
              className="flex p-2 bg-[#c97c5d]  text-white font-semibold rounded hover:bg-orange-300 transition-all duration-300"
              onClick={() => {
                localStorage.removeItem("token");
                navigate("/");
              }}
            >
              <GoSignOut className="text-xl mr-2 my-auto "/> Sign Out
            </button>
          
        </div>
      </div>

      {/* Main Content */}
      <div className="mt-20 w-full flex justify-center items-start">
        {renderSection()}
      </div>
    </div>
  );
};

export default Sidebar;
